import React, { useState } from "react";
import { CheckedInIcon } from "src/components/CheckedIn/CheckedInIcon";
import { CheckedInAction } from "src/components/CheckedIn/CheckedInSiteStyles";
import { Post } from "./viewerApi";
import { ViewerCheckIn } from "./ViewerCheckIn";
import { PostAsset, PostCard, PostContent, PostMedia, PostTextButton } from "./ViewerStyles";

interface ViewerPostProps {
    post: Post;
    detail: boolean;
    checkInBusy: boolean;
    onOpen: () => void;
    onBack: () => void;
    onCheckIn: () => void;
}

export function ViewerPost({ post, detail, checkInBusy, onOpen, onBack, onCheckIn }:
    ViewerPostProps): React.ReactElement {
    const [mediaFailed, setMediaFailed] = useState<boolean>(false);
    const imageUrl: string | undefined = post.image?.imageUrl || post.video?.previewImageUrl;
    const description: string = post.message || "";
    const truncated: boolean = !detail && description.length > 160;
    return <PostCard $detail={detail}>
        <PostAsset $detail={detail}>
            {!mediaFailed && (post.video?.videoUrl || imageUrl) && <PostMedia $detail={detail}>
                {detail && post.video?.videoUrl ? (
                    <video key={post.video.videoUrl} src={post.video.videoUrl} poster={imageUrl} controls playsInline
                        preload="metadata" aria-label={post.subject || "Post video"} onError={() => setMediaFailed(true)} />
                ) : !detail ? (
                    <button type="button" onClick={onOpen} aria-label={`Open ${post.subject || "post"}`}>
                        {imageUrl ? <img src={imageUrl} alt="" loading="lazy" onError={() => setMediaFailed(true)} />
                            : <video src={post.video.videoUrl} muted playsInline preload="metadata" />}
                    </button>
                ) : <img src={imageUrl} alt={post.subject || ""} onError={() => setMediaFailed(true)} />}
            </PostMedia>}
            {detail && <CheckedInAction type="button" $round onClick={onBack} aria-label="Back to posts">
                <CheckedInIcon name="back" />
            </CheckedInAction>}
        </PostAsset>
        <PostContent>
            <h2>{detail ? post.subject : <PostTextButton type="button" onClick={onOpen}>
                {post.subject || "View post"}</PostTextButton>}</h2>
            {description && <p>{truncated ? `${description.slice(0, 160).trimEnd()}…` : description}</p>}
            {truncated && <PostTextButton type="button" onClick={onOpen}>Show More</PostTextButton>}
            {detail && post.audio?.audioUrl && <audio controls src={post.audio.audioUrl} preload="metadata" />}
            {post.checkIn && <ViewerCheckIn checkIn={post.checkIn} detail={detail} busy={checkInBusy} onToggle={onCheckIn} />}
        </PostContent>
    </PostCard>;
}
